import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import React from "react";
import { twMerge } from "tailwind-merge";

export type DetailFieldProps = React.ComponentProps<"div"> & {
  label: React.ReactNode;
  className?: string;
};

export const DetailField: React.FC<DetailFieldProps> = React.forwardRef<
  HTMLDivElement,
  DetailFieldProps
>(({ label, className, children }, ref) => {
  const scaffold = useScaffold();
  const DetailLabel = scaffold.page.detail.detailLabel;
  return (
    <div ref={ref} className={twMerge("flex flex-col gap-1", className)}>
      <DetailLabel>{label}</DetailLabel>
      <div className={clsx("text-sm", scaffold.page.colors.text.secondary)}>
        {children}
      </div>
    </div>
  );
});
